import {
  ModalContentPayloadData,
  ModalOptionPayloadData,
  ModalStylePayloadData,
} from './modalShared';

export enum ModalType {
  ANTRAG_EINREICHEN_ERROR = 'ANTRAG_EINREICHEN_ERROR',
  ANTRAG_EINREICHEN_TECHID_ERROR = 'ANTRAG_EINREICHEN_TECHID_ERROR',
  AUSGEWAEHLTES_PRODUKT_NICHT_TARIFIERT_ERROR = 'AUSGEWAEHLTES_PRODUKT_NICHT_TARIFIERT_ERROR',
  BEIBEHALTENEN_VORVERTRAG_NICHT_GUELTIG = 'BEIBEHALTENEN_VORVERTRAG_NICHT_GUELTIG',
  BEIBEHALTENEN_VORVERTRAG_WURDE_GEAENDERT = 'BEIBEHALTENEN_VORVERTRAG_WURDE_GEAENDERT',
  CORRELATION_ID_REQUESTED_BY_KEY = 'CORRELATION_ID_REQUESTED_BY_KEY',
  DELETE_WARNING = 'DELETE_WARNING',
  DELETE_WARNING_MULTIPLE_ANGEBOTE = 'DELETE_WARNING_MULTIPLE_ANGEBOTE',
  DOPPELVERSICHERUNGS_ERROR = 'DOPPELVERSICHERUNGS_ERROR',
  FEHLER_VORVERTRAG_NOT_MATCH_OR_NOK = 'FEHLER_VORVERTRAG_NOT_MATCH_OR_NOK',
  FORWARD_TO_UNDERWRITER = 'FORWARD_TO_UNDERWRITER',
  FORWARD_TO_UNDERWRITER_ERROR = 'FORWARD_TO_UNDERWRITER_ERROR',
  FORWARD_TO_AGENT_ERROR = 'FORWARD_TO_AGENT_ERROR',
  FREMDVERTRAG_NICHT_UMGESTELLT_ERROR = 'FREMDVERTRAG_NICHT_UMGESTELLT_ERROR',
  FREMDVN_WARENKORB_HINWEIS = 'FREMDVN_WARENKORB_HINWEIS',
  GESUNDHEITSDATEN_DELETED = 'GESUNDHEITSDATEN_DELETED',
  MULTIPLE_RS_VORVERTRAEGE = 'MULTIPLE_RS_VORVERTRAEGE',
  NAVIGATION_ERROR = 'NAVIGATION_ERROR',
  PLZ_REQUIRES_UW_CHECK_ERROR = 'PLZ_REQUIRES_UW_CHECK_ERROR',
  PREISE_CHECKOUT_ERROR = 'PREISE_CHECKOUT_ERROR',
  PREISE_SHOP_ERROR = 'PREISE_SHOP_ERROR',
  PS10_VERTRAEGE_HINWEIS = 'PS10_VERTRAEGE_HINWEIS',
  RELOAD_NACH_BACKEND_ODER_APP_VERSIONS_CHANGE = 'RELOAD_NACH_BACKEND_ODER_APP_VERSIONS_CHANGE',
  RESET_ADRESSDATEN_WARNING = 'RESET_ADRESSDATEN_WARNING',
  RISIKOORT_REQUESTED_ERROR = 'RISIKOORT_REQUESTED_ERROR',
  STANDALONE_EINSCHLIESSEN_WARNING = 'STANDALONE_EINSCHLIESSEN_WARNING',
  STANDALONE_VERTRAG_UMSTELLUNG_FEHLER = 'STANDALONE_VERTRAG_UMSTELLUNG_FEHLER',
  TAAS_FEHLER_MIT_RETRY = 'TAAS_FEHLER_MIT_RETRY',
  TAAS_FEHLER_OHNE_RETRY = 'TAAS_FEHLER_OHNE_RETRY',
  TARIFIERUNG_STRECKE_ERROR = 'TARIFIERUNG_STRECKE_ERROR',
  TKV_TIERART_NICHT_MEHR_GUELTIG = 'TKV_TIERART_NICHT_MEHR_GUELTIG',
  TREUE_BONUS_KONTO_ERROR = 'TREUE_BONUS_KONTO_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  VORSCHLAG_DRUCK_ERROR = 'VORSCHLAG_DRUCK_ERROR',
  FILE_DOWNLOAD_ERROR = 'FILE_DOWNLOAD_ERROR',
  VORVERTRAEGE_STATUS_CHANGED = 'VORVERTRAEGE_STATUS_CHANGED',
  VORVERTRAG_BEIBEHALTEN_BEINHALTET_RISIKOADRESSE_VON_WARENKORB = 'VORVERTRAG_BEIBEHALTEN_BEINHALTET_RISIKOADRESSE_VON_WARENKORB',
  VORVERTRAG_BEIBEHALTEN_MINDESTENS_EINE_UMSTELLUNG = 'VORVERTRAG_BEIBEHALTEN_MINDESTENS_EINE_UMSTELLUNG',
  VORVERTRAG_NICHT_UMGESTELLT_ERROR = 'VORVERTRAG_NICHT_UMGESTELLT_ERROR',
  VORVERTRAG_PRODUKT_HINWEIS = 'VORVERTRAG_PRODUKT_HINWEIS',
  VORVERTRAG_PRODUKT_HINWEIS_ABBRECHEN_WEITER = 'VORVERTRAG_PRODUKT_HINWEIS_ABBRECHEN_WEITER',
  VORVERTRAG_UMSTELLUNG_PH_MIT_ALTE_KOMBIPRODUKTE = 'VORVERTRAG_UMSTELLUNG_PH_MIT_ALTE_KOMBIPRODUKTE',
  VP_ALTER_CHANGED = 'VP_ALTER_CHANGED',
}

export interface ModalRequested {
  type: ModalType;
  content?: Partial<ModalContentPayloadData>;
  style?: Partial<ModalStylePayloadData>;
  options?: Partial<ModalOptionPayloadData>;
}
